import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { CPSURL } from '../../../libs/proto/mobile_pb';

@Injectable({
  providedIn: 'root'
})
export class CPSURLConversionService {

  constructor() { }

  ToStorage(req: CPSURL) {
    const w = new BinaryWriter();
    CPSURL.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (CPSURL: CPSURL, errorConvert: any) => void) {
    try {
      callback( CPSURL.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(CPSURLs: CPSURL[]) {
    const rets = new Array<Uint8Array | number[]>();

    CPSURLs.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (CPSURLs: CPSURL[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<CPSURL>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = CPSURL.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
